import { Api } from "./Api";
import _ from "lodash";
import { Relance } from "../models/Relance";
import axios from "axios";

export class RelanceApi extends Api {
    constructor() {
        super("relance");
    }

    getAll(params?: Object): Promise<Array<Relance>> {
        return this.getResources(params).then(function (response) {
            var res: Array<Relance> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new Relance(d);
                });
            }
            return res;
        });
    }

    getAllWithPagination(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            var relances: Array<Relance> = [];
            if (response.data && response.data.data) {
                relances = _.map(response.data.data, function (d) {
                    return new Relance(d);
                });
            }
            return {
                data: relances,
                metadata: response.data.metadata || [],
                paginator: response.data.paginator || {
                    current_page: 1,
                    limit: 50,
                    total_count: relances.length,
                    total_pages: 1,
                },
            };
        });
    }

    get(id: Number, params?: Object): Promise<Relance> {
        return this.getResource(id, params).then(function (response) {
            return new Relance(response.data.data);
        });
    }

    save(relance: Relance, params?: Object): Promise<Relance> {
        return super
            .saveResource(relance.serialize(), params)
            .then(function (response) {
                return new Relance(response.data.data);
            });
    }

    create(relance: Relance, params?: Object): Promise<Relance> {
        return super
            .createResource(relance.serialize(), params)
            .then(function (response) {
                return new Relance(response.data.data);
            });
    }

    update(id: Number, relance: Relance, params?: Object): Promise<Relance> {
        return super
            .updateResource(id, relance.serialize(), params)
            .then(function (response) {
                return new Relance(response.data.data);
            });
    }

    delete(id: Number): Promise<Relance> {
        return super.deleteResource(id).then(function (response) {
            return new Relance(response.data.data);
        });
    }

    importExcel(file: File): Promise<any> {
        const formData = new FormData();
        formData.append("file", file);

        return axios.post(`${this.apiUrl}import-excel`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }
}
